import React from 'react';
import { useTranslation } from 'react-i18next';
import { NotificationSubscriptionBanner } from '@/components/ProfileMenu/NotificationsView/NotificationSubscriptionBanner';
import { SettingRow } from '@/components/ProfileMenu/NotificationsView/SettingRow';
import { useProfileRestriction } from '@/components/ProfileRestriction/useProfileRestriction';
import { LockClosed } from '@/components/Icons/LockClosed';
import { PhoneNotification } from '@/components/Icons/PhoneNotification';
import { useShowSubscriptionOffer } from '@/hooks/useShowSubscriptionOffer';

const PREMIUM_ITEMS = [
  'diaryMessages',
  'behaviourEntries',
  'evaluations',
  'nonAttendances',
  'homeworks',
] as const;

const leadingIcon = (
  <PhoneNotification className="size-4 shrink-0 text-subtle-foreground" />
);

interface Props {
  isSubscribed: boolean;
  viewOnly?: boolean;
  onPurchase: () => void;
}

export const PushSection: React.FC<Props> = ({
  isSubscribed,
  viewOnly = false,
  onPurchase,
}) => {
  const { t } = useTranslation();
  const { isRestricted } = useProfileRestriction();
  const showSubscriptionOffer = useShowSubscriptionOffer();

  const premiumSubtitle =
    isSubscribed || isRestricted
      ? ''
      : t('notificationSettings.subscriberOnly');

  const premiumTrailing = isSubscribed ? undefined : (
    <LockClosed className="size-6 shrink-0 text-subtle-foreground" />
  );

  return (
    <>
      <div className="mx-4 flex flex-col rounded-xl bg-background">
        <SettingRow
          leading={leadingIcon}
          title={t('notificationSettings.pushCommunication')}
          subtitle=""
        />
      </div>

      {!isRestricted && (
        <p className="px-4 text-subhead-14 text-foreground">
          {t('notificationSettings.subscriberSectionTitle')}
        </p>
      )}

      {showSubscriptionOffer && !viewOnly && (
        <NotificationSubscriptionBanner onPurchase={onPurchase} />
      )}

      <div className="mx-4 mb-4 flex flex-col rounded-xl bg-background">
        {PREMIUM_ITEMS.map((item, index) => (
          <SettingRow
            key={item}
            leading={leadingIcon}
            title={t(`notificationSettings.${item}`)}
            subtitle={premiumSubtitle}
            trailing={premiumTrailing}
            hasDivider={index < PREMIUM_ITEMS.length - 1}
          />
        ))}
      </div>
    </>
  );
};
